import en from './locales/en.json';
import ko from './locales/ko.json';

export const resources = {
  en: {
    translation: en
  },
  ko: {
    translation: ko
  }
};

export const supportedLanguages = Object.keys(resources);
